import * as Types from '../../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type MergeProductionSpaceCategoryMutationVariables = Types.Exact<{
  input: Types.MergeProductionSpaceCategoryInput;
}>;


export type MergeProductionSpaceCategoryMutation = { __typename?: 'Mutation', mergeProductionSpaceCategory: { __typename?: 'ProductionSpaceCategoryPayload', productionSpaceCategory?: { __typename?: 'ProductionSpaceCategoryStateData', tenantId: string, productionSpaceCategoryId: string, code: string, length: number, width: number, stagger: boolean, status: Types.ProductionSpaceCategoryStatus, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type ActivateProductionSpaceCategoryMutationVariables = Types.Exact<{
  input: Types.ActivateProductionSpaceCategoryInput;
}>;


export type ActivateProductionSpaceCategoryMutation = { __typename?: 'Mutation', activateProductionSpaceCategory: { __typename?: 'ProductionSpaceCategoryPayload', productionSpaceCategory?: { __typename?: 'ProductionSpaceCategoryStateData', tenantId: string, productionSpaceCategoryId: string, code: string, length: number, width: number, stagger: boolean, status: Types.ProductionSpaceCategoryStatus, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type DeactivateProductionSpaceCategoryMutationVariables = Types.Exact<{
  input: Types.DeactivateProductionSpaceCategoryInput;
}>;


export type DeactivateProductionSpaceCategoryMutation = { __typename?: 'Mutation', deactivateProductionSpaceCategory: { __typename?: 'ProductionSpaceCategoryPayload', productionSpaceCategory?: { __typename?: 'ProductionSpaceCategoryStateData', tenantId: string, productionSpaceCategoryId: string, code: string, length: number, width: number, stagger: boolean, status: Types.ProductionSpaceCategoryStatus, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type DeleteProductionSpaceCategoryMutationVariables = Types.Exact<{
  input: Types.DeleteProductionSpaceCategoryInput;
}>;


export type DeleteProductionSpaceCategoryMutation = { __typename?: 'Mutation', deleteProductionSpaceCategory: { __typename?: 'ProductionSpaceCategoryPayload', productionSpaceCategory?: { __typename?: 'ProductionSpaceCategoryStateData', tenantId: string, productionSpaceCategoryId: string, code: string, length: number, width: number, stagger: boolean, status: Types.ProductionSpaceCategoryStatus, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type SetSpaceDimensionOverrideMutationVariables = Types.Exact<{
  input: Types.SetSpaceDimensionOverrideInput;
}>;


export type SetSpaceDimensionOverrideMutation = { __typename?: 'Mutation', setSpaceDimensionOverride: { __typename?: 'ProductionSpaceCategoryPayload', productionSpaceCategory?: { __typename?: 'ProductionSpaceCategoryStateData', tenantId: string, productionSpaceCategoryId: string, code: string, length: number, width: number, stagger: boolean, status: Types.ProductionSpaceCategoryStatus, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type ClearSpaceDimensionOverrideMutationVariables = Types.Exact<{
  input: Types.ClearSpaceDimensionOverrideInput;
}>;


export type ClearSpaceDimensionOverrideMutation = { __typename?: 'Mutation', clearSpaceDimensionOverride: { __typename?: 'ProductionSpaceCategoryPayload', productionSpaceCategory?: { __typename?: 'ProductionSpaceCategoryStateData', tenantId: string, productionSpaceCategoryId: string, code: string, length: number, width: number, stagger: boolean, status: Types.ProductionSpaceCategoryStatus, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type CommitSpaceRebalanceMutationVariables = Types.Exact<{
  input: Types.CommitSpaceRebalanceInput;
}>;


export type CommitSpaceRebalanceMutation = { __typename?: 'Mutation', commitSpaceRebalance: { __typename?: 'CommitSpaceRebalancePayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type MergeProductionSpaceTypeMutationVariables = Types.Exact<{
  input: Types.MergeProductionSpaceTypeInput;
}>;


export type MergeProductionSpaceTypeMutation = { __typename?: 'Mutation', mergeProductionSpaceType: { __typename?: 'ProductionSpaceTypePayload', productionSpaceType?: { __typename?: 'ProductionSpaceTypeStateData', tenantId: string, productionSpaceTypeId: string, code: string, status: Types.ProductionSpaceTypeStatus, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type ActivateProductionSpaceTypeMutationVariables = Types.Exact<{
  input: Types.ActivateProductionSpaceTypeInput;
}>;


export type ActivateProductionSpaceTypeMutation = { __typename?: 'Mutation', activateProductionSpaceType: { __typename?: 'ProductionSpaceTypePayload', productionSpaceType?: { __typename?: 'ProductionSpaceTypeStateData', tenantId: string, productionSpaceTypeId: string, code: string, status: Types.ProductionSpaceTypeStatus, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type DeactivateProductionSpaceTypeMutationVariables = Types.Exact<{
  input: Types.DeactivateProductionSpaceTypeInput;
}>;


export type DeactivateProductionSpaceTypeMutation = { __typename?: 'Mutation', deactivateProductionSpaceType: { __typename?: 'ProductionSpaceTypePayload', productionSpaceType?: { __typename?: 'ProductionSpaceTypeStateData', tenantId: string, productionSpaceTypeId: string, code: string, status: Types.ProductionSpaceTypeStatus, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type DeleteProductionSpaceTypeMutationVariables = Types.Exact<{
  input: Types.DeleteProductionSpaceTypeInput;
}>;


export type DeleteProductionSpaceTypeMutation = { __typename?: 'Mutation', deleteProductionSpaceType: { __typename?: 'ProductionSpaceTypePayload', productionSpaceType?: { __typename?: 'ProductionSpaceTypeStateData', tenantId: string, productionSpaceTypeId: string, code: string, status: Types.ProductionSpaceTypeStatus, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };


export const MergeProductionSpaceCategoryDocument = new TypedDocumentString(`
    mutation MergeProductionSpaceCategory($input: MergeProductionSpaceCategoryInput!) {
  mergeProductionSpaceCategory(input: $input) {
    productionSpaceCategory {
      ...ProductionSpaceCategoryDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionSpaceCategoryDetails on ProductionSpaceCategoryStateData {
  tenantId
  productionSpaceCategoryId
  code
  length
  width
  stagger
  status
  createdAt
  createdBy
  updatedAt
  updatedBy
}`);
export const ActivateProductionSpaceCategoryDocument = new TypedDocumentString(`
    mutation ActivateProductionSpaceCategory($input: ActivateProductionSpaceCategoryInput!) {
  activateProductionSpaceCategory(input: $input) {
    productionSpaceCategory {
      ...ProductionSpaceCategoryDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionSpaceCategoryDetails on ProductionSpaceCategoryStateData {
  tenantId
  productionSpaceCategoryId
  code
  length
  width
  stagger
  status
  createdAt
  createdBy
  updatedAt
  updatedBy
}`);
export const DeactivateProductionSpaceCategoryDocument = new TypedDocumentString(`
    mutation DeactivateProductionSpaceCategory($input: DeactivateProductionSpaceCategoryInput!) {
  deactivateProductionSpaceCategory(input: $input) {
    productionSpaceCategory {
      ...ProductionSpaceCategoryDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionSpaceCategoryDetails on ProductionSpaceCategoryStateData {
  tenantId
  productionSpaceCategoryId
  code
  length
  width
  stagger
  status
  createdAt
  createdBy
  updatedAt
  updatedBy
}`);
export const DeleteProductionSpaceCategoryDocument = new TypedDocumentString(`
    mutation DeleteProductionSpaceCategory($input: DeleteProductionSpaceCategoryInput!) {
  deleteProductionSpaceCategory(input: $input) {
    productionSpaceCategory {
      ...ProductionSpaceCategoryDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionSpaceCategoryDetails on ProductionSpaceCategoryStateData {
  tenantId
  productionSpaceCategoryId
  code
  length
  width
  stagger
  status
  createdAt
  createdBy
  updatedAt
  updatedBy
}`);
export const SetSpaceDimensionOverrideDocument = new TypedDocumentString(`
    mutation SetSpaceDimensionOverride($input: SetSpaceDimensionOverrideInput!) {
  setSpaceDimensionOverride(input: $input) {
    productionSpaceCategory {
      ...ProductionSpaceCategoryDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionSpaceCategoryDetails on ProductionSpaceCategoryStateData {
  tenantId
  productionSpaceCategoryId
  code
  length
  width
  stagger
  status
  createdAt
  createdBy
  updatedAt
  updatedBy
}`);
export const ClearSpaceDimensionOverrideDocument = new TypedDocumentString(`
    mutation ClearSpaceDimensionOverride($input: ClearSpaceDimensionOverrideInput!) {
  clearSpaceDimensionOverride(input: $input) {
    productionSpaceCategory {
      ...ProductionSpaceCategoryDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionSpaceCategoryDetails on ProductionSpaceCategoryStateData {
  tenantId
  productionSpaceCategoryId
  code
  length
  width
  stagger
  status
  createdAt
  createdBy
  updatedAt
  updatedBy
}`);
export const CommitSpaceRebalanceDocument = new TypedDocumentString(`
    mutation CommitSpaceRebalance($input: CommitSpaceRebalanceInput!) {
  commitSpaceRebalance(input: $input) {
    errors {
      code
      message
    }
  }
}
    `);
export const MergeProductionSpaceTypeDocument = new TypedDocumentString(`
    mutation MergeProductionSpaceType($input: MergeProductionSpaceTypeInput!) {
  mergeProductionSpaceType(input: $input) {
    productionSpaceType {
      ...ProductionSpaceTypeDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionSpaceTypeDetails on ProductionSpaceTypeStateData {
  tenantId
  productionSpaceTypeId
  code
  status
  createdAt
  createdBy
  updatedAt
  updatedBy
}`);
export const ActivateProductionSpaceTypeDocument = new TypedDocumentString(`
    mutation ActivateProductionSpaceType($input: ActivateProductionSpaceTypeInput!) {
  activateProductionSpaceType(input: $input) {
    productionSpaceType {
      ...ProductionSpaceTypeDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionSpaceTypeDetails on ProductionSpaceTypeStateData {
  tenantId
  productionSpaceTypeId
  code
  status
  createdAt
  createdBy
  updatedAt
  updatedBy
}`);
export const DeactivateProductionSpaceTypeDocument = new TypedDocumentString(`
    mutation DeactivateProductionSpaceType($input: DeactivateProductionSpaceTypeInput!) {
  deactivateProductionSpaceType(input: $input) {
    productionSpaceType {
      ...ProductionSpaceTypeDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionSpaceTypeDetails on ProductionSpaceTypeStateData {
  tenantId
  productionSpaceTypeId
  code
  status
  createdAt
  createdBy
  updatedAt
  updatedBy
}`);
export const DeleteProductionSpaceTypeDocument = new TypedDocumentString(`
    mutation DeleteProductionSpaceType($input: DeleteProductionSpaceTypeInput!) {
  deleteProductionSpaceType(input: $input) {
    productionSpaceType {
      ...ProductionSpaceTypeDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionSpaceTypeDetails on ProductionSpaceTypeStateData {
  tenantId
  productionSpaceTypeId
  code
  status
  createdAt
  createdBy
  updatedAt
  updatedBy
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    MergeProductionSpaceCategory: build.mutation<MergeProductionSpaceCategoryMutation, MergeProductionSpaceCategoryMutationVariables>({
      query: (variables) => ({ document: MergeProductionSpaceCategoryDocument, variables })
    }),
    ActivateProductionSpaceCategory: build.mutation<ActivateProductionSpaceCategoryMutation, ActivateProductionSpaceCategoryMutationVariables>({
      query: (variables) => ({ document: ActivateProductionSpaceCategoryDocument, variables })
    }),
    DeactivateProductionSpaceCategory: build.mutation<DeactivateProductionSpaceCategoryMutation, DeactivateProductionSpaceCategoryMutationVariables>({
      query: (variables) => ({ document: DeactivateProductionSpaceCategoryDocument, variables })
    }),
    DeleteProductionSpaceCategory: build.mutation<DeleteProductionSpaceCategoryMutation, DeleteProductionSpaceCategoryMutationVariables>({
      query: (variables) => ({ document: DeleteProductionSpaceCategoryDocument, variables })
    }),
    SetSpaceDimensionOverride: build.mutation<SetSpaceDimensionOverrideMutation, SetSpaceDimensionOverrideMutationVariables>({
      query: (variables) => ({ document: SetSpaceDimensionOverrideDocument, variables })
    }),
    ClearSpaceDimensionOverride: build.mutation<ClearSpaceDimensionOverrideMutation, ClearSpaceDimensionOverrideMutationVariables>({
      query: (variables) => ({ document: ClearSpaceDimensionOverrideDocument, variables })
    }),
    CommitSpaceRebalance: build.mutation<CommitSpaceRebalanceMutation, CommitSpaceRebalanceMutationVariables>({
      query: (variables) => ({ document: CommitSpaceRebalanceDocument, variables })
    }),
    MergeProductionSpaceType: build.mutation<MergeProductionSpaceTypeMutation, MergeProductionSpaceTypeMutationVariables>({
      query: (variables) => ({ document: MergeProductionSpaceTypeDocument, variables })
    }),
    ActivateProductionSpaceType: build.mutation<ActivateProductionSpaceTypeMutation, ActivateProductionSpaceTypeMutationVariables>({
      query: (variables) => ({ document: ActivateProductionSpaceTypeDocument, variables })
    }),
    DeactivateProductionSpaceType: build.mutation<DeactivateProductionSpaceTypeMutation, DeactivateProductionSpaceTypeMutationVariables>({
      query: (variables) => ({ document: DeactivateProductionSpaceTypeDocument, variables })
    }),
    DeleteProductionSpaceType: build.mutation<DeleteProductionSpaceTypeMutation, DeleteProductionSpaceTypeMutationVariables>({
      query: (variables) => ({ document: DeleteProductionSpaceTypeDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useMergeProductionSpaceCategoryMutation, useActivateProductionSpaceCategoryMutation, useDeactivateProductionSpaceCategoryMutation, useDeleteProductionSpaceCategoryMutation, useSetSpaceDimensionOverrideMutation, useClearSpaceDimensionOverrideMutation, useCommitSpaceRebalanceMutation, useMergeProductionSpaceTypeMutation, useActivateProductionSpaceTypeMutation, useDeactivateProductionSpaceTypeMutation, useDeleteProductionSpaceTypeMutation } = injectedRtkApi;
